import { prop } from 'ramda';

import { compact } from '../../../helpers/compact';
import { DocumentType } from '../../../types/document';
import { FILTER, MENU } from '../../../types/filters';
import { toRichTextFromProp, toText } from '../fields/text';
import { image } from '../partials/image';
import { deprecatedPageEntity } from './internal';

/**
 * @typedef  {Object} PrismicBranchActivities
 */

/**
 * @typedef {DocumentSchema} BranchActivitiesSchema
 */

/**
 * Transform the given input into objects for Gouvernance sections
 *
 * @param  {PrismicGouvernance} data
 * @return {GouvernanceSchema}
 */
const processBranchActivities = (data) =>
  compact({
    uid: DocumentType.BRANCH_ACTIVITIES,
    breadcrumb: toText(data?.breadcrumb || data?.title || data?.meta_title),
    type: DocumentType.BRANCH_ACTIVITIES,
    chapeau: prop('chapeau', data),
    illustration: image(data),
    txt: {
      type: 'text',
      body: toRichTextFromProp('txt', data),
    },
    filters: {
      [FILTER.MENU]: MENU.ACTIVITY,
    },
  });

/**
 * Normalizr schema representing an article
 */
export const BranchActivities = deprecatedPageEntity(
  DocumentType.BRANCH_ACTIVITIES,
  {
    processStrategy: (entity) => ({
      ...processBranchActivities(prop('data', entity)),
    }),
  }
);
